// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"dd8d786d","266":"a6ec4361","278":"33859b3f","441":"e62e3175","519":"9a63d69a","554":"6b7c4bab","670":"404b2307"}[chunkId] + ".chunk.css";
};